import {ExpressPaymentButtonSection} from 'coreStore/data/basket/types';
import {expressPaymentButtonStyles} from 'brandConstants';

export const getPayPalButtonStylesBySection = (
	section: ExpressPaymentButtonSection,
	isMobile: boolean
) => {
	switch (section) {
		case ExpressPaymentButtonSection.PDP:
			return {
				height: isMobile ?
					expressPaymentButtonStyles?.payPal?.pdp?.xs :
					expressPaymentButtonStyles?.payPal?.pdp?.lg
			};
		default:
			return {};
	}
};
